interface NumberRangeFilterProps {
  label: string
  minValue: string
  maxValue: string
  onMinChange: (value: string) => void
  onMaxChange: (value: string) => void
  minPlaceholder?: string
  maxPlaceholder?: string
}

export function NumberRangeFilter({
  label,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  minPlaceholder = "Od",
  maxPlaceholder = "Do",
}: NumberRangeFilterProps) {
  return (
    <div className="space-y-1 sm:col-span-2">
      <label className="text-xs font-medium text-muted-foreground">
        {label}
      </label>
      <div className="flex items-center gap-2">
        <input
          type="number"
          value={minValue || ""}
          onChange={(e) => onMinChange(e.target.value)}
          placeholder={minPlaceholder}
          className="h-8 flex-1 rounded-md border border-input bg-transparent px-2 text-sm text-foreground outline-none tabular-nums"
        />
        <span className="text-xs text-muted-foreground">
          -
        </span>
        <input
          type="number"
          value={maxValue || ""}
          onChange={(e) => onMaxChange(e.target.value)}
          placeholder={maxPlaceholder}
          className="h-8 flex-1 rounded-md border border-input bg-transparent px-2 text-sm text-foreground outline-none tabular-nums"
        />
      </div>
    </div>
  )
}
